import ClickstreamService from '../services/clickstream-service';
import {
  EventFormatterBuilderFactory,
  EventFormatterType
} from '@unified-client/event-formatter';
import { getSystemData } from '@unified-client/system-data';
import buildVersion from '../version';
import Global from '../global';
import ClickstreamConfig from '../config/clickstream';
import { v4 as uuid } from 'uuid';

export default {
  sendEventToClickstream: (event, level, logData = {}) => {
    
    const initFormatter = setInitFormatter();

    const date = new Date().toISOString();
    const {
      brand,
      globalSessionId,
      playerSessionId,
      productPackage,
      cid,
      offering,
      publicationId,
      countryISO3,
      currency
    } = logData;

    const formattedMessage = initFormatter.formatUCEvent(
      { message: event.type, durationInMS: event.durationInMS },
      {
        correlationID: uuid(),
        sessionData: {
          globalSessionID: globalSessionId,
          playerSessionID: playerSessionId
        },
        userData: {
          cid,
          brand: '',
          brandID: brand,
          offering,
          publicationId,
          countryISO3,
          currency
        },
        productPackageID: productPackage,
        level
      },
      {
        date,
        ...event,
        ...logData
      }
    );

    ClickstreamService.sendEventToClickstream(formattedMessage).catch(
      err => err
    );
  }
};

const setInitFormatter = ()  => {
  const correlationId = uuid();

    const { ipv4, ipv6, hostname } = getSystemData();
    const { environment, systemId } = Global.config;
    const { index } = ClickstreamConfig();

    const initEventFormatterBuilderFactory = new EventFormatterBuilderFactory({
      type: EventFormatterType.Server,
      settings: {
        environment: environment,
        target: index,
        sessionID: correlationId
      },
      sender: {
        ipv4,
        ipv6,
        serverName: hostname,
        systemID: systemId,
        buildNumber: buildVersion,
        versionNumber: buildVersion
      }
    });
    const initEventFormatterBuilder = initEventFormatterBuilderFactory.createEventFormatterBuilder(
      'client'
    );
    const initFormatter = initEventFormatterBuilder.createFormatter(
      'log',
      { correlationID: correlationId }
    );

    return initFormatter;
};
